// extracted by mini-css-extract-plugin
export default {"respBodyJson":"APIBody_respBodyJson__UJMuq","nextBtn":"APIBody_nextBtn__mtEyd"};